import React from "react";

export default function MainContainer ({children}) {
    return (
        <div style={{width:"100%", aspectRatio:"16/9", position:"relative"}}>
            {children}
        </div>
    )
}